import { render, staticRenderFns } from "./customerContractHistoryDetail.vue?vue&type=template&id=427c4748"
import script from "./customerContractHistoryDetail.vue?vue&type=script&lang=js"
export * from "./customerContractHistoryDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports